import React, { useState, useRef, useEffect } from "react";
import { Alert, Button, Col, Container, Row } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import Image from "react-bootstrap/Image";
import Modal from "react-bootstrap/Modal";
import PubSub from "pubsub-js";

import UserImage from "../../assets/img/img_avatar.png"
import fuziElevatorsApi from "../../api/fuziElevatorsApi";
import { validationMessages } from "../../utils/messages";
import { regExPattern } from "../../utils/regExPattern";
// import { faRecordVinyl } from "@fortawesome/free-solid-svg-icons";

const UserProfileEdit = ({ userId }) => {
  const fileInputRef = useRef();
  const [profile, setProfile] = useState({});
  //errors state
  const [errors, setErrors] = useState({});
  useEffect(() => {
    console.log("errors", errors);
  }, [errors]);

  const [body, setBody] = useState();
  const [show, setShow] = useState(false);
  const [user, setUser] = useState({ password: "", confirmpassword: "" });
  //eslint-disable-next-line
  const [validated, setValidated] = useState(false);

  const [selectedFiles, setSelectedFiles] = useState(null);

  useEffect(() => {
    async function init() {
      let result = await fuziElevatorsApi.getLoginUserData();
      // console.log('result', result);
      if (result?.errors) {
        PubSub.publish("RECORD_ERROR_TOAST", {
          title: "Record Save Error",
          message: result.errors,
        });
      } else {
        setProfile(result);
      }
      let files = await fuziElevatorsApi.fetchFiles(result.id, 'users');
      // console.log('files', files);
      // setFile(files?.id || null);
      setSelectedFiles(files);
      if (files && files.length > 0) {
        let file = files[0];
        let downloadresult = await fuziElevatorsApi.downloadFiles(file.id);
        file.body = window.URL.createObjectURL(downloadresult);
        setBody(file.body);
      }
    }

    init();
  }, []);

  const handlePasswordOnchange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name == "firstname") {
      if (value != "" && e?.target?.pattern && (!RegExp(e.target.pattern).test(value))) {
        setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.firstName.invalid } }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    }
    if (name == "lastname") {
      if (value != "" && e?.target?.pattern && (!RegExp(e.target.pattern).test(value))) {
        setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.lastName.invalid } }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    }
    else if (name == "email") {
      if (value != "" && e?.target?.pattern && (!RegExp(e.target.pattern).test(value))) {
        setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.email.invalid } }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    }
    else if (name === "phone") {
      if (value != "" && e?.target?.pattern && (!RegExp(e.target.pattern).test(value))) {
        setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.phone.invalid } }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    }
    setProfile({ ...profile, [name]: value });
  };

  // field validators
  const checkRequiredFields = () => {
    let isError = false;


    if (profile?.firstname) {
      if (
        profile?.firstname != "" &&
        regExPattern?.name &&
        !RegExp(regExPattern.name).test(profile.firstname)
      ) {
        setErrors((prev) => ({
          ...prev,
          email: { message: validationMessages.firstName.invalid },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["firstname"];
          return { ...prev };
        });
      }
    }

    if (profile?.lastname) {
      if (
        profile?.lastname != "" &&
        regExPattern?.name &&
        !RegExp(regExPattern.name).test(profile.lastname)
      ) {
        setErrors((prev) => ({
          ...prev,
          email: { message: validationMessages.lastName.invalid },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["lastname"];
          return { ...prev };
        });
      }
    }

    if (profile?.email) {
      if (
        profile?.email != "" &&
        regExPattern?.email &&
        !RegExp(regExPattern.email).test(profile.email)
      ) {
        setErrors((prev) => ({
          ...prev,
          email: { message: validationMessages.email.invalid },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["email"];
          return { ...prev };
        });
      }
    }

    if (profile?.phone) {
      if (
        profile?.phone != "" &&
        regExPattern?.phone &&
        !RegExp(regExPattern.phone).test(profile.phone)
      ) {
        setErrors((prev) => ({
          ...prev,
          phone: { message: validationMessages.phone.invalid },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["phone"];
          return { ...prev };
        });
      }
    }

    return isError;
  };

  const handleSubmit = async (event) => {

    event.preventDefault();
    console.log("profile", profile);
    console.log("errors", errors);
    if (checkRequiredFields()) {
      setValidated(true);
      return;
    }
    console.log("profile", profile);
    console.log("errors", errors);

    if (Object?.keys(errors)?.length != 0) {
      setValidated(true);
      return;
    }

    let result = {};
    if (selectedFiles === null) {
      result = await fuziElevatorsApi.saveUser(profile);
      if (result.success) {
        PubSub.publish("RECORD_SAVED_TOAST", {
          title: "Record Saved",
          message: "Record saved successfully",
        });
      } else {
        PubSub.publish("RECORD_ERROR_TOAST", {
          title: "Record Save Error",
          message: result.errors,
        });
      }
    } else {
      // eslint-disable-next-line
      let result = await fuziElevatorsApi.saveStaffMemberEditProfile(
        profile.id,
        selectedFiles,
        JSON.stringify(JSON.stringify(profile))
      );
      console.log('result', result);
      // localStorage.setItem("myimage", body);
      PubSub.publish("RECORD_SAVED_TOAST", {
        title: "Record Saved",
        message: " Record update successfully",
      });
    }
  };

  const handlePhotoUpload = (event) => {
    setBody(URL.createObjectURL(event.target.files[0]));
    setSelectedFiles(event.target.files[0]);
  };

  const handleClose = () => setShow(false);

  const handleChangeSubmit = async (e) => {

    // setShow(true);
    e.preventDefault();
    if (user.password === user.confirmpassword && user.password !== "") {
      //eslint-disable-next-line
      const result = await fuziElevatorsApi.updateUser(user);
      setShow(false);
      PubSub.publish("RECORD_SAVED_TOAST", {
        title: "Record Saved",
        message: "Password updated successfully",
      });
    }
  };


  return (
    <Container>
      <Row className="justify-content-center">
        <Col lg={3}>
          <Card>
            <Card.Body className="text-center">
              <Card.Title style={{ textAlign: "center" }}>
                {profile.firstname} {profile.lastname}
              </Card.Title>
              <Image
                variant="top"
                src={body || UserImage}
                className="rounded-circle"
                thumbnail
                style={{ width: "200px" }}
              ></Image>
              <br />
              <Button
                className="btn my-3 "
                variant="secondary"
                style={{ width: "100%", display: "block" }}
                onClick={() => fileInputRef.current.click()}
              >
                Image Upload
              </Button>
              <Button
                className="btn"
                style={{ width: "100%", display: "block" }}
                variant="danger"
                onClick={() => setShow(true)}
              >
                Change Password
              </Button>
              <input
                onChange={handlePhotoUpload}
                name="profilephotourl"
                ref={fileInputRef}
                type="file"
                hidden
              />
            </Card.Body>
          </Card>
        </Col>

        <Col className="bg-white" lg={7}>
          <Form
            className=""
            onSubmit={() => handleSubmit}
            noValidate
            validated={validated}
          >
            <Row className="view-form-header align-items-center">
              <Col lg={6}>Edit Profile</Col>
              <Col lg={6} className="d-flex justify-content-end">
                <Button size="sm" className="btn-save" onClick={handleSubmit}>
                  Save
                </Button>
              </Col>
            </Row>

            <Row className="pb-5 py-3">
              <Col lg={6} className="pb-3">
                <Form.Group >
                  <Form.Label
                    className="form-view-label"
                    htmlFor="formBasicPhone"
                  >
                    First Name
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="firstname"
                    value={profile.firstname || ''}
                    onChange={handleChange}
                    pattern={regExPattern.name}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors?.firstname?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col lg={6} className="pb-3">
                <Form.Group>
                  <Form.Label
                    className="form-view-label"
                    htmlFor="formBasicPhone"
                  >
                    Last Name
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="lastname"
                    placeholder="Enter Last Name"
                    value={profile.lastname || ''}
                    onChange={handleChange}
                    pattern={regExPattern.name}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors?.lastname?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col lg={6} className="pb-3">
                <Form.Group>
                  <Form.Label
                    className="form-view-label"
                    htmlFor="formBasicPhone"
                  >
                    Email
                  </Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    placeholder="Enter Email"
                    value={profile.email || ''}
                    onChange={handleChange}
                    pattern={regExPattern.email}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors?.email?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col lg={6} className="pb-3">
                <Form.Group>
                  <Form.Label
                    className="form-view-label"
                    htmlFor="formBasicPhone"
                  >
                    Phone
                  </Form.Label>
                  <Form.Control
                    type="phone"
                    name="phone"
                    placeholder="Enter Phone"
                    value={profile.phone || ''}
                    onChange={handleChange}
                    maxLength={10}
                    pattern={regExPattern.phone}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors?.phone?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
          </Form>

        </Col>
      </Row>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Change Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>

            {user.password !== user.confirmpassword && <Col lg={12} ><Alert variant={'danger'}>Password and confirm password are not same </Alert></Col>}

            <Col lg={12}>
              <Form className="mt-3">
                <Row>
                  <Col>
                    <Form.Group className="mx-3" controlId="formBasicFirstName">
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicFirstName"
                      >
                        New Password
                      </Form.Label>
                      <Form.Control
                        type="password"
                        name="password"
                        placeholder="Enter Your password"
                        onChange={handlePasswordOnchange}
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group className="mx-3" controlId="formBasicPhone">
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicPhone"
                      >
                        Confirm Password
                      </Form.Label>
                      <Form.Control
                        type="password"
                        name="confirmpassword"
                        placeholder="Enter confirm password"
                        onChange={handlePasswordOnchange}
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleChangeSubmit}>
            Save
          </Button>
          <Button variant="danger" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default UserProfileEdit;